// Session timeout manager - uses window events to avoid race conditions
class SessionTimeoutManager {
  constructor() {
    this.EVENT_NAME = 'SESSION_TIMEOUT';
  }

  // Show session timeout by dispatching a custom event
  showSessionTimeout() {
    console.log('SessionTimeoutManager: Dispatching SESSION_TIMEOUT event');
    window.dispatchEvent(new CustomEvent(this.EVENT_NAME));
  }

  // Listen for session timeout events
  onSessionTimeout(callback) {
    console.log('SessionTimeoutManager: Registering listener for', this.EVENT_NAME);
    window.addEventListener(this.EVENT_NAME, callback);
  }

  // Remove listener
  offSessionTimeout(callback) {
    window.removeEventListener(this.EVENT_NAME, callback);
  }

  handleRelogin(redirectPath = '/') {
    console.log('SessionTimeoutManager: Clearing session and redirecting to:', redirectPath);
    // Clear authentication data
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('role');
    localStorage.removeItem('partnerCode');
    localStorage.removeItem('plan_id');
    
    // Redirect to login
    window.location.href = redirectPath;
  }
}

export const sessionTimeoutManager = new SessionTimeoutManager();
